import React from "react";

import PropTypes from "prop-types";

import {
  Button,
  Divider,
  Modal,
  Link,
  SocialLinks,
  Spacer,
} from "components/ui/source";
import { navigationLinks } from "components/ui/source/util/constants";

import { IconX } from "icons";
import { ACCOUNT_TYPE } from "types/sonder/source";

import { useNavbarRendered } from "./Navbar";

import styles from "./MenuModal.module.scss";

function MenuModal({ isOpen, onOpen, onClose, actions }) {
  const modalProps = {
    isOpen,
    onRequestOpen: onOpen,
    onRequestClose: onClose,
    contentLabel: "Mobile Menu Modal",
    className: styles.modal_content,
  };
  const isNavbarRendered = useNavbarRendered();

  const CloseButton = () => (
    <div className={styles.close_container}>
      <Button type="no_background" onClick={onClose}>
        <div className={styles.close_button}>
          <IconX size="xl" />
        </div>
      </Button>
    </div>
  );

  const Links = () => (
    <div className={styles.links_container}>
      {Object.keys(navigationLinks).map(section =>
        navigationLinks[section].map(link => {
          return (
            <Link
              textTypes={["align_center", "body1", "light"]}
              translateKey={`footer.${section}.links.${link["name"]}.label`}
              href={link["url"]}
              key={link["name"]}
            />
          );
        }),
      )}
    </div>
  );

  return isNavbarRendered ? (
    <Modal modalProps={modalProps}>
      <CloseButton />
      <Spacer size="s-5x" />
      <div className={styles.sonder_logo}>
        <img
          height={30}
          src="https://images.sonder.com/image/upload/q_100,f_auto,e_sharpen:100,dpr_2.0/v1737485839/sondercom/partners/sonderByMarriottLogo.png"
          alt={"sonder"}
          fetchPriority="high"
        />
      </div>

      {actions}
      <Divider spacerSize="s-5x" />
      <SocialLinks color="black" />
      <Spacer size="s-1x" />
      <Links />
    </Modal>
  ) : null;
}

MenuModal.propTypes = {
  account: ACCOUNT_TYPE.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  actions: PropTypes.node,
};

MenuModal.defaultProps = {
  onOpen: () => {},
  onClose: () => {},
  actions: null,
};

export default MenuModal;
